import { ReactNode } from 'react';
import Footer from './Footer';
import PromoBanner from './PromoBanner';

interface LayoutProps {
  children: ReactNode;
  showFooter?: boolean;
  /**
   * 運営者の Misskey サーバー紹介バナーをフッターの直前に出すか。
   * 未ログインでも見られる紹介系ページだけで有効にする想定のため既定は false。
   * （管理画面・課金フロー・結果画面に広告を差し込まないための既定値）
   */
  showPromo?: boolean;
}

export default function Layout({ children, showFooter = true, showPromo = false }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <div className="flex-1 flex flex-col">
        {children}
      </div>
      {showPromo && <PromoBanner />}
      {showFooter && <Footer />}
    </div>
  );
}
